import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import Moment from "moment"
import { LoadModal } from "../modais"
class TableContratos extends Component {
  constructor() {
    super()
    this.getFicha = this.getFicha.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false
    }
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  getFicha(id) {
    this.toggleLoadModal()
    ApiHelper.getFichaContrato(id, (ficha, error) => {
      this.toggleLoadModal()
      if (ficha) {
        var url = URL.createObjectURL(ficha)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Ficha Contrato Número:" + id + ".pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  render() {
    var tableHeaders = [
      "Número do contrato",
      "Objeto",
      "Contratado",
      "Assinado em",
      "Final da vigência",
      "Ações"
    ]
    return (
      <div>
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <table className="table table-hover">
          <thead className="text-warning">
            <tr>
              {tableHeaders.map((header, key) => {
                return <th key={key}>{header}</th>
              })}
            </tr>
          </thead>
          <tbody>
            {this.props.rows.map((row, key) => {
              return (
                <tr key={key}>
                  <td className="col-md-2">{row.num_contrato}</td>
                  <td className="col-sm-5">{row.objeto}</td>
                  <td className="col-sm-4">
                    {row.contratado ? row.contratado.nome_razao_social : "N/A"}
                  </td>
                  <td className="col-sm-2">
                    {Moment(row.data_assinado).format("D/MM/Y")}
                  </td>
                  <td className="col-sm-2">
                    {row.final_vigencia.date
                      ? Moment(row.final_vigencia.date).format("D/MM/Y")
                      : Moment(row.final_vigencia).format("D/MM/Y")}
                  </td>
                  <td className="col-sm-1 td-actions text-right">
                    <Link
                      className="btn btn-primary btn-simple btn-xs"
                      title="Gerenciar contrato"
                      to={"/contratos/gerenciar/" + row.id}
                    >
                      <i className="material-icons">settings</i>
                    </Link>
                    <Link
                      title="Editar contrato"
                      className="btn btn-primary btn-simple btn-xs"
                      to={"/contratos/edit/" + row.id}
                    >
                      <i className="material-icons">edit</i>
                    </Link>
                    <button
                      onClick={event => this.getFicha(row.id)}
                      type="button"
                      rel="tooltip"
                      title="Vizualizar contrato"
                      className="btn btn-info btn-simple btn-xs"
                    >
                      <i className="material-icons">local_printshop</i>
                    </button>
                    <Link
                      title="Ir para a tela de contratos"
                      className="btn btn-primary btn-simple btn-xs"
                      to={"/contratos"}
                    >
                      <i className="material-icons">forward</i>
                    </Link>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}
export default withRouter(TableContratos)



// WEBPACK FOOTER //
// ./src/views/contratos/TableNavContratos.js